import API from "Classes/Api";
import {
  ApiGetCallParams,
  ApiPostCallParams,
  ApiPutCallParams,
  ApiDeleteCallParams,
} from "Classes/ApiCallParams";
import { SetDefaultViewResponse } from "./ViewsTypes";

class ViewsService extends API {
  async getViews({ clientId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/users/self/preferences/filter-profiles`,
        headers: { ...API.getAuthHeaders() },
      })
    );

    return result;
  }

  async getView({ clientId, userFilterProfileId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/users/self/preferences/filter-profiles/${userFilterProfileId}`,
        headers: { ...API.getAuthHeaders() },
      })
    );

    return result;
  }

  async createView({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/users/self/preferences/filter-profiles`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        successMessage: "A new view has been created.",
      })
    );

    return result;
  }

  async updateView({ clientId, userFilterProfileId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/users/self/preferences/filter-profiles/${userFilterProfileId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        successMessage: "The view was successfully updated.",
      })
    );

    return result;
  }

  async deleteView({ clientId, userFilterProfileId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `/v2/clients/${clientId}/users/self/preferences/filter-profiles/${userFilterProfileId}`,
        headers: { ...API.getAuthHeaders() },
        successMessage: "The view was successfuly deleted.",
      })
    );

    return result;
  }

  async createGlobalView({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/users/global/preferences/filter-profiles`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        successMessage: "A new view has been created.",
      })
    );

    return result;
  }

  async updateGlobalView({ clientId, userFilterProfileId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/users/global/preferences/filter-profiles/${userFilterProfileId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        successMessage: "The view was successfully updated.",
      })
    );

    return result;
  }

  async deleteGlobalView({ clientId, userFilterProfileId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `/v2/clients/${clientId}/users/global/preferences/filter-profiles/${userFilterProfileId}`,
        headers: { ...API.getAuthHeaders() },
        successMessage: "The view was successfuly deleted.",
      })
    );

    return result;
  }

  async setDefaultView(clientId: number, viewId: number | null): Promise<SetDefaultViewResponse> {
    return await super.call(
      new ApiPutCallParams({
        action: `v2/clients/${clientId}/users/self/preferences/filter-profiles/default`,
        headers: { ...API.getAuthHeaders() },
        body: { id: viewId },
      })
    );
  }

  async setDefaultPerformanceTemplate(
    clientId: number,
    viewId: number | null
  ): Promise<SetDefaultViewResponse> {
    return await super.call(
      new ApiPutCallParams({
        action: `v2/clients/${clientId}/users/self/preferences/performance-counter-templates/default`,
        headers: { ...API.getAuthHeaders() },
        body: { id: viewId },
      })
    );
  }
}

const instance = new ViewsService();
export default instance;
